import React from "react";
import { useMount } from "react-use";

import { AxiosError } from "axios";
import LoadingAndErrorBoundary from "../../../../commons/LoadingAndErrorBoundary";
import { LoadingIndicator, LoadingOverlay } from "../../../../../components";
import RlCloudSandboxCarouselWrapper from "./RlCloudSandboxCarouselWrapper";
import { show } from "../../../../../notifications/notifications";
import { NotificationsLevel } from "../../../../../lib/enums";
import { HttpError } from "../../../../commons/erorrs/errors";
import { SCREENSHOT_ERROR_MAP } from "../consts";

type Props = {
  hash: string;
  isNetwork: boolean;
  activeAnalysisId: string;
  loadingIndicator?: boolean;
};

type ErrorFallbackProps = {
  error: { error: AxiosError };
};

const ScreenshotsErrorMessage: React.FC<ErrorFallbackProps> = ({
  error: { error: axiosError }
}) => {
  useMount(() => {
    const errStatus = axiosError?.response?.status ?? HttpError.HTTP_50X;
    show({
      level: NotificationsLevel.ERROR,
      message:
        errStatus in SCREENSHOT_ERROR_MAP
          ? SCREENSHOT_ERROR_MAP[errStatus]
          : SCREENSHOT_ERROR_MAP[HttpError.HTTP_50X]
    });
  });

  return (
    <div className="rl-cloud-sandbox__modal_error">
      <h3>No Available Screenshots For This Analysis</h3>
      <p>
        Try reanalyzing the sample using RL Cloud Sandbox to fetch new
        screenshots. If sample is not stored locally, use Fetch & Analyze option
        for public samples.
      </p>
    </div>
  );
};
const RlCloudSandboxScreenshots: React.FC<Props> = ({
  hash,
  isNetwork,
  activeAnalysisId,
  loadingIndicator = false
}) => (
  <div className="rl-cloud-sandbox__modal-content">
    <LoadingAndErrorBoundary
      key={activeAnalysisId}
      errorFallback={ScreenshotsErrorMessage}
      suspenseFallback={
        loadingIndicator ? <LoadingIndicator /> : <LoadingOverlay />
      }
    >
      <RlCloudSandboxCarouselWrapper
        hash={hash}
        activeAnalysisId={activeAnalysisId}
        isNetwork={isNetwork}
      />
    </LoadingAndErrorBoundary>
  </div>
);

export default RlCloudSandboxScreenshots;
